import { action, observable } from 'mobx';
import { ADVISOR_RANKINGS } from 'api/endpoints';
import { AmountValue } from 'common/interfaces';
import { RootStore } from 'stores/rootStore';

interface Ranking {
  rank: number;
  code: string;
  aum: AmountValue;
  portfolioAum: AmountValue;
  accounts: number;
  investments: AmountValue;
  current?: boolean;
}

interface RankingsData {
  total: number;
  rankings: Ranking[];
}

export class RankingsStore {
  rootStore: RootStore;
  @observable data?: RankingsData = undefined;
  @observable period = 'ALL_TIME';
  @observable orderBy = 'AUM';

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action setPeriod = (value: string) => {
    this.period = value;
    this.fetchData();
  };

  @action setOrderBy = (value: string) => {
    this.orderBy = value;
    this.fetchData();
  };

  @action
  fetchData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const { apiStore } = this.rootStore.stores;
    const response = await apiStore.get<RankingsData>(ADVISOR_RANKINGS(this.period, this.orderBy));
    this.data = response?.data;
    this.rootStore.stores.uiStore.setLoading(false);
  };
}
